
import SubscribeWithEmailCTA from "./SubscribeWithEmailCTA.vue";
import SubscribeWithGoogleCTA from "./SubscribeWithGoogleCTA.vue";
import Headings from "./Headings.vue";
import EndMessage from "./EndMessage.vue";
import WfPetImg from "./WfPetImg.vue";

export default {
	name: "NewsletterBanner",
	components: {
		SubscribeWithEmailCTA,
		SubscribeWithGoogleCTA,
		Headings,
		EndMessage,
		WfPetImg,
	},
};
